import { changeAcceptedDocumentsVisible } from 'features/verify/features/accepted-documents';
import { ClockIcon, CreditCardIcon, ShieldIcon } from 'features/verify/ui/icons';
import { queryString } from 'libs/query-string';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { useStore } from 'effector-react';

import { navigate } from 'libs/router';
import { Button } from 'ui/atoms/button';
import { sendEvent } from 'model/helpers/events.model';
import { routes } from 'features/verify/routes';
import { countryCode$, openLinkParams$ } from 'model/main.model';
import { sessionConfig$ } from 'model/session.model';
import { OnboardLayout } from 'features/verify/ui/onboard-layout';
import { ButtonContainer } from 'features/verify/ui/button-container';
import { localizationOptions$, useLocalization } from 'model/localization.model';

export const Welcome = () => {
	const t = useLocalization();
	const session = useStore(sessionConfig$);
	const code = useStore(countryCode$);
	const options = useStore(localizationOptions$);
	const openLinkParams = useStore(openLinkParams$);
	const { urls } = useStore(sessionConfig$);
	const [start] = useState(Date.now());

	const handleContinue = () => {
		navigate(routes.access);
		sendEvent({
			event: 'welcome_screen_continue',
			event_attributes: {
				type: 'mobile',
				duration: Date.now() - start,
			},
		});
	};

	useEffect(() => {
		screenHistoryPush(ScreenName.welcome_mobile);
		setTimeout(() => {
			sendEvent({
				event: 'welcome_screen_shown',
				event_attributes: {
					type: 'mobile',
					geoip_country: code,
					ua: window.navigator.userAgent,
					language: options.language || 'en',
					from: queryString.decode(openLinkParams?.q)?.from || null,
				},
			});
		}, 20);
	}, []);

	return (
		<OnboardLayout
			title={t('welcome.title')}
			subtitle={t('welcome.subtitle', {
				company: session.company,
			})}
			info={[{
				icon: <CreditCardIcon/>,
				text: <span
					onClick={(e: any) => {
						if (e.target.classList.contains('view.accepted.documents')) {
							changeAcceptedDocumentsVisible(true);
						}
					}}
					dangerouslySetInnerHTML={{
						__html: t('handoff.welcome.hint.1', {
							'view.accepted.documents': `<a
									class="view.accepted.documents"
								>${t('view.accepted.documents')}</a>`,
						}),
					}}
				/>,
			}, {
				icon: <ShieldIcon/>,
				text: <Fragment>
					<span
						dangerouslySetInnerHTML={{
							__html: t('handoff.welcome.hint.2', {
								company: session.company,
								'welcome.hint.tos.sub': `<a
									target='_blank'
									rel='nofollow noopener noreferrer'
									href='${urls.tos_url}'
								>${t('welcome.hint.tos.sub')}</a>`
							})
						}}
					/>
				</Fragment>,
			}, {
				icon: <ClockIcon/>,
				text: <Fragment>
					{t('handoff.welcome.hint.3')}
				</Fragment>,
			}]}
		>
			<ButtonContainer>
				<Button
					name={'mobile_welcome_continue'}
					onClick={handleContinue}
				>
					{t('welcome.btn')}
				</Button>
			</ButtonContainer>
		</OnboardLayout>
	);
};
